<template>
    <!-- DESCR：论文录用出版页面 -->
    <div class="proceedingspapers-box">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Proceedings Papers</div>
                    <br />
                    <div class="info">
                        You can view all the submission files that will be accepted for publication on this page
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="warning" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 会议投稿论文列表 -->
        <div class="paperlist-box">
            <div class="click-tips">
                <span class="text-line">Color explanation: this paper is checked, this paper is not checked.
                </span>
                <div class="tools-box">
                    <div class="tools-left">
                        <el-tooltip class="box-item" effect="dark"
                            content="Compile all submitted papers and provide a compressed file for you"
                            placement="top">
                            <el-tag style="cursor: pointer;margin-right: 10px;" @click="production" type="warning"
                                v-show="checkPermission([`${$route.query.cid}.publish`])">production</el-tag>
                        </el-tooltip>
                        <el-tooltip class="box-item" effect="dark"
                            content="Organize and organize all submitted papers, and provide you with a collection of papers"
                            placement="top">
                            <el-tag style="cursor: pointer;margin-right: 10px;" @click="collection" type="warning"
                                v-show="checkPermission([`${$route.query.cid}.publish`])">collection of essays</el-tag>
                        </el-tooltip>
                    </div>
                    <div class="tools-left">
                        <el-tag style="cursor: pointer;margin-right: 10px;" @click="confdesc" type="warning">Conference
                            Desc</el-tag>
                    </div>
                </div>
            </div>
            <el-table :data="conferencePaperList" style="width: 100%" border @sort-change="sortTable" class="tb-box">
                <template #empty>
                    <el-empty description="Data is loading..." />
                </template>
                <el-table-column label="Id" width="100" align="center" sortable="custom" header-align="center">
                    <template #default="scope">
                        <span>{{ scope.row.autoid }}</span>
                    </template>
                </el-table-column>
                <el-table-column width="400" label="Authors" align="left" header-align="center">
                    <template #default="scope">
                        <el-text class="author-text">{{ scope.row.authors }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="Title" align="left" header-align="center">
                    <template #default="scope">
                        <el-text class="title-text">{{ scope.row.title }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column label="Operate" width="50" align="center" header-align="center">
                    <template #header>
                        <div class="vertical-text">View or update</div>
                    </template>
                    <template #default="scope">
                        <el-icon>
                            <View @click="look(scope.$index, scope.row)" />
                        </el-icon>
                    </template>
                </el-table-column>
                <el-table-column label="Operate" width="50" align="center" header-align="center">
                    <template #header>
                        <div class="vertical-text">PDF</div>
                    </template>
                    <template #default="scope">
                        <svg class="icon" aria-hidden="true" @click="download(scope.$index, scope.row)">
                            <use xlink:href="#icon-pdf"></use>
                        </svg>
                    </template>
                </el-table-column>
                <el-table-column label="Operate" width="50" align="center" header-align="center">
                    <template #header>
                        <div class="vertical-text">Zip or Word</div>
                    </template>
                    <template #default="scope">
                        <svg class="icon" aria-hidden="true" @click="downloadWord(scope.$index, scope.row)"
                            v-if="scope.row.wordtype == 'zip'">
                            <use xlink:href="#icon-zip-1"></use>
                        </svg>
                        <svg class="icon" aria-hidden="true" @click="downloadWord(scope.$index, scope.row)"
                            v-if="scope.row.wordtype == 'doc' || scope.row.wordtype == 'docx'">
                            <use xlink:href="#icon-doc"></use>
                        </svg>
                    </template>
                </el-table-column>
                <el-table-column label="Operate" width="50" align="center" header-align="center">
                    <template #header>
                        <div class="vertical-text">Copyright form</div>
                    </template>
                    <template #default="scope">
                        <svg class="icon" aria-hidden="true" @click="downloadCopy(scope.$index, scope.row)"
                            v-if="scope.row.copyfileurl != null">
                            <use xlink:href="#icon-banquan_"></use>
                        </svg>
                    </template>
                </el-table-column>
                <el-table-column label="Operate" width="50" align="center" header-align="center">
                    <template #header>
                        <div class="vertical-text">Types</div>
                    </template>
                    <template #default="scope">
                        <el-tooltip class="box-item" effect="dark" :content="scope.row.typesname" placement="bottom">
                            <svg class="icon" aria-hidden="true" v-if="scope.row.typesname != null">
                                <use xlink:href="#icon-beijianleixing-"></use>
                            </svg>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 构建发布模版 -->
        <el-dialog v-model="diaEditPushShow" title="Edit Template" width="55%" style="margin-top: 1%;" center>
            <el-form label-width="230px" label-position="right">
                <el-form-item label="Preface:">
                    <el-input v-model="confinfo.preface" autocomplete="off" type="textarea" resize="none"
                        :autosize="{ minRows: 10, maxRows: 17 }" />
                </el-form-item>
                <el-form-item label="City:">
                    <el-input v-model="confinfo.pushaddr" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Date:">
                    <el-input v-model="confinfo.pushdate" autocomplete="off" />
                </el-form-item>
                <el-form-item label="Name:">
                    <el-input v-model="confinfo.pushname" autocomplete="off" type="textarea" resize="none"
                        :autosize="{ minRows: 3, maxRows: 10 }" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="diaEditPushShow = false" style="width: 150px;">Cancel</el-button>
                    <el-button type="primary" @click="downloadZip" style="width: 150px;">
                        Confirm
                    </el-button>
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStore } from 'vuex'
import { useRouter, useRoute } from "vue-router";
import { saveAs } from 'file-saver';
import { ElMessage } from 'element-plus'
import request from "../../network/request"
import checkPermission from "../../utils/checkPermission"
import { View, Document, Refresh, Position, Search, Plus, Message, ArrowLeftBold } from '@element-plus/icons-vue'
import axios from 'axios'
import { ElLoading } from 'element-plus'


const route = useRoute()
const router = useRouter()

// 投稿录用论文
const conferencePaperList = ref([])
// 论文集下载弹出层
const diaEditPushShow = ref(false)
// 会议前言描述
const confinfo = ref({})
// 排序规则
const sortRule = ref("id asc")

onMounted(() => {
    // 获取投稿录用论文
    getConferencePaperList()
})

// 获取会议投稿论文列表
function getConferencePaperList() {
    conferencePaperList.value = []
    request.get(`/copyright/list?cid=${route.query.cid}`).then((res) => {
        conferencePaperList.value = res.data
        conferencePaperList.value.forEach(item => {
            item.wordtype = item.wordfileurl?.split('/').pop().split('.').pop();
        })
        conferencePaperList.value.sort((a, b) => {
            return a.autoid - b.autoid;
        });
    })
}

// 获取排序列和排序规则，交由后端负责排序
const sortTable = (payload) => {
    if (payload.column.order == "ascending") {
        let ordercol = payload.column.label.toLowerCase() == 'id' ? 'autoid' : payload.column.label.toLowerCase()
        sortRule.value = ordercol + " " + payload.column.order.substring(0, 3)
        getConferencePaperList()
    }
    else if (payload.column.order == "descending") {
        let ordercol = payload.column.label.toLowerCase() == 'id' ? 'autoid' : payload.column.label.toLowerCase()
        sortRule.value = ordercol + " " + payload.column.order.substring(0, 4)
        getConferencePaperList()
    }
    else {
        sortRule.value = "createtime desc"
        getConferencePaperList()
    }

}

// 查看论文详细信息
const look = (index, row) => {
    router.push(`/common/detailpaperprods?cid=${route.query.cid}&pid=${row.pid}&acronym=${route.query.acronym}&autoid=${row.autoid}`)
}

// 下载PDF论文文件
const download = (index, payload) => {
    saveAs(payload.pdffileurl, `paper_${payload.autoid}.pdf`)
}

// 下载Word论文文件
const downloadWord = (index, payload) => {
    saveAs(payload.wordfileurl, `paper_${payload.autoid}.${payload.wordtype}`)
}

// 下载版权书
const downloadCopy = (index, payload) => {
    saveAs(payload.copyfileurl, `paper_${payload.autoid}.pdf`)
}

// 路由跳转到会议详细页
const confdesc = () => {
    let sublink = route.query.acronym.replace("_", "").replace(" ", "").toLowerCase()
    router.push(`/common/submitpaper?conf=${sublink}`)
}

// 下载编版论文压缩包（预处理界面）
const production = () => {
    diaEditPushShow.value = true
    request.post(`/conference/detail`, { cid: route.query.cid }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        if (res.code == 200) {
            confinfo.value.preface = res.data.preface
            confinfo.value.pushdate = res.data.pushdate
            confinfo.value.pushaddr = res.data.pushaddr
            confinfo.value.pushname = res.data.pushname
        }
    })
}

// 去除空格全部转为大写
function convertToUpperCaseAndRemoveSpaces(str) {
    return str.toUpperCase().replace(/\s/g, '');
}

// 下载整理排版论文集
const collection = () => {
    const loading = ElLoading.service({
        // 加载进度条
        lock: true,
        text: 'The paper is currently being arranged and organized',
        background: 'rgba(0, 0, 0, 0.7)',
    })
    request.post(`/paper/publish/${route.query.cid}`, { cid: route.query.cid }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: `Start downloading`,
                type: 'success',
            })
            saveAs(res.data.url, `${convertToUpperCaseAndRemoveSpaces(route.query.acronym)}论文集.pdf`)
            loading.close()
        }
    })
}


// 下载论文集（后置下载压缩包）
const downloadZip = () => {
    const loading = ElLoading.service({
        // 加载进度条
        lock: true,
        text: 'Compiling a collection of papers',
        background: 'rgba(0, 0, 0, 0.7)',
    })
    request.post(`/paper/production/${route.query.cid}`, { preface: confinfo.value.preface, pushdate: confinfo.value.pushdate, pushaddr: confinfo.value.pushaddr, pushname: confinfo.value.pushname }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: `zip export successful`,
                type: 'success',
            })
            saveAs(res.data.url, res.data.name)
            diaEditPushShow.value = false
            loading.close()
        }

    })
}
</script>


<style lang="scss">
.proceedingspapers-box {
    position: absolute;
    top: 100px;
    left: 50px;
    right: 50px;
    bottom: 20px;

    .vertical-text {
        writing-mode: vertical-rl;
        /* 或者 vertical-lr */
        text-orientation: right;
        /* 保持文字方向正常，可以省略 */
        white-space: nowrap;
        /* 防止文字换行 */
        font-size: 12px;
        padding: 10px 0;
        font-weight: normal;
        text-align: center;
    }

    .login-title {
        background: #fde2b72e;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .send-box {
        .el-col {
            margin-bottom: 10px;
        }

        .choice-send {
            position: relative;

            .el-avatar {
                width: 46px;
                height: 46px;
            }

            .email-text {
                font-size: 13px;
            }

            .el-card__body {
                display: flex;
                align-items: center;
            }

            .check {
                position: absolute;
                top: -1px;
                right: 10px;
            }

            .status {
                position: absolute;
                bottom: 5px;
                right: 10px;
            }

        }
    }

    .page-tools {
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }

    .tools-box {
        display: flex;
        justify-content: space-between;
    }

    .click-tips {
        font-size: 13px;

        .text-line {
            border-bottom: 1px solid #88b5cb61;
            display: inline-block;
            margin-bottom: 20px;
            padding-bottom: 5px;
        }

        div {
            margin-bottom: 10px;
        }
    }

    .tb-box {
        .author-text {
            font-size: 13px;
        }

        .title-text {
            font-size: 13px;
        }

        svg {
            cursor: pointer;
        }
    }

}
</style>